import { render } from "./StrokesTeamActionsOverview.vue?vue&type=template&id=44a56fe7"
import script from "./StrokesTeamActionsOverview.vue?vue&type=script&lang=js"
export * from "./StrokesTeamActionsOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__